export type TFileSlicerParams = { file: File; chunkSize: number; baseSlice: number }

export class FileSlicer {
  public slices: number
  public currentSlice: number
  public size: number
  private params: TFileSlicerParams

  constructor (params: TFileSlicerParams) {
    const { file, chunkSize, baseSlice = 0 } = params
    this.params = params
    this.slices = Math.ceil((file.size - baseSlice * chunkSize) / chunkSize)
    this.currentSlice = baseSlice || 0
    this.size = file.size
  }
  public getNextSlice () {
    const { file, chunkSize } = this.params
    const start = this.currentSlice * chunkSize
    const end = Math.min((this.currentSlice + 1) * chunkSize, file.size)
    this.currentSlice += 1
    return file.slice(start, end)
  }
  /**
     * destroy
     */
  public destroy () {
    // @ts-ignore
    this.slices = null
    // @ts-ignore
    this.currentSlice = null
    // @ts-ignore
    this.size = null
    // @ts-ignore
    this.params = null
  }
}

// type TFileSlicer = { currentSlice: number, slices: number, getNextSlice: Function }
// function FileSlicer(file: File, chunkSize: number, baseSlice = 0) {
//     // @ts-ignore
//     const than = this as TFileSlicer

//     than.slices = Math.ceil((file.size - baseSlice * chunkSize) / chunkSize)
//     than.currentSlice = baseSlice || 0

//     than.getNextSlice = function getNextSlice() {
//         const start = than.currentSlice * chunkSize
//         const end = Math.min((than.currentSlice + 1) * chunkSize, file.size)
//         ++than.currentSlice
//         return file.slice(start, end)
//     }
// }

export function calcChunkHash (blob: Blob): Promise<string> {
  // @ts-ignore
  const spark = new SparkMD5.ArrayBuffer()
  const fileReader = new FileReader()
  return new Promise(resolve => {
    fileReader.readAsArrayBuffer(blob)
    fileReader.onload = e => {
      spark.append(e?.target?.result) // Append array buffer
      resolve(spark.end())
    }
  })
}

export const toOctetStream = (num: number, size: number): Blob => {
  const getInt64Bytes = (x: number): number[] => {
    const bytes = []
    let i = 8
    do {
      // @ts-ignore
      bytes[--i] = x & (255)
      // eslint-disable-next-line no-bitwise
      x >>= 8
    } while (i)
    return bytes
  }
  const buf = new ArrayBuffer(size)
  const int8Ary = new Int8Array(buf)
  const content = getInt64Bytes(num).slice(8 - size, 8)
  for (let i = 0; i < size; i++) {
    int8Ary[i] = content[i]
  }

  return new Blob([int8Ary], { type: 'application/octet-stream' })
}

export function getAppropriateChunkSize (size: number): number {
  // 100M - 500M 2M
  // 500M - 1024M 5M
  // 1024M - 10M
  const unitM = 1024 * 1024 * 1
  if (size < unitM * 500) {
    return unitM * 2
  } else if (size < unitM * 1024) {
    return unitM * 5
  } else {
    return unitM * 10
  }
}